import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Shop from "../pages/Shop";
import ScrollToHashElement from "./ScrollToHashElement";
import AGB from "../pages/Agb";
import InjectorDetailPage from "../pages/InjectorDetailPage/InjectorDetailPage";
import Impressum from "../pages/Impressum";
import Retouren from "../pages/Retouren";
import Datenschutzerklarung from "../pages/Datenschutzerklarung";
import Widerrufsrecht from "../pages/Widerrufsrecht";
import Versandbedingungen from "../pages/Versandbedingungen";
import ServiceBerlin from "../pages/ServiceBerlin";
import ServiceEU from "../pages/ServiceEU";
import UberUns from "../pages/UberUns";
import Kontakt from "../pages/Kontakt";
import FAQ from "../pages/FAQ";
import Partner from "../pages/Partner";
import Karriere from "../pages/Karriere";
import Reviews from "@/pages/Reviews";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentFailed from "@/pages/PaymentFailed";
import FeedbackSuccess from "@/pages/FeedbackSuccess";
import Checkout from "@/pages/Checkout";
import NotFound from "@/pages/NotFound/NotFound";

const AppRoutes = () => {
  return (
    <>
      <ScrollToHashElement />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />

        {/* Маршрути для категорій з SEO-friendly URL */}
        <Route path="/shop/:categoryId/:categoryName" element={<Shop />} />

        <Route path="/agb" element={<AGB />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/retouren" element={<Retouren />} />
        <Route
          path="/datenschutzerklarung"
          element={<Datenschutzerklarung />}
        />
        <Route path="/widerrufsrecht" element={<Widerrufsrecht />} />
        <Route path="/versandbedingungen" element={<Versandbedingungen />} />
        <Route path="/product/:id/:name" element={<InjectorDetailPage />} />

        <Route
          path="/leistungen-werkstatt-berlin/"
          element={<ServiceBerlin />}
        />
        <Route path="/leistungen-de_at/" element={<ServiceEU />} />
        <Route path="/uber-uns/" element={<UberUns />} />
        <Route path="/kontakt/" element={<Kontakt />} />
        <Route path="/faq/" element={<FAQ />} />
        <Route path="/unsere-partner/" element={<Partner />} />
        <Route path="/karriere/" element={<Karriere />} />
        <Route path="/reviews/" element={<Reviews />} />
        <Route path="/payment_success/" element={<PaymentSuccess />} />
        <Route path="/payment_failed/" element={<PaymentFailed />} />
        <Route path="/feedback_success/" element={<FeedbackSuccess />} />
        <Route path="/checkout/" element={<Checkout />} />

        {/* 404 Page - Must be last route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
